import { ChangeDetectionStrategy, Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { ContentType } from '../../../../models/content.enum';
import { FORM_NEW_ITEM_ID } from './../../../../config/forms.config';
import { NavigateService } from './../../../../core/authentication/services/navigate/navigate.service';
import { Pages } from '../../../../models/pages.enum';
import { TranslocoService } from '@ngneat/transloco';
import { URL_ROUTER } from 'apps/arsultima/src/app/utils/url-router';
import { Utils } from './../../../../utils/utils';

@Component({
  selector: 'arsultima-slide-subheader',
  templateUrl: './slide-subheader.component.html',
  styleUrls: ['./slide-subheader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush, // important otherwise the images will be redownloaded uselessly due to time refresher
})
export class SlideSubheaderComponent implements OnInit {
  @Input()
  id = FORM_NEW_ITEM_ID;

  @Input()
  imageUrl: string;

  @Input()
  page: Pages;

  @Input()
  copyright: string;

  @Input()
  isEditable = true;

  @Input()
  height = '150px';

  @Input()
  isHome = false;

  contentType = ContentType;

  imageUrlWithRefresh: string;

  translated = {
    editSlide: '',
    createSlide: '',
  };

  constructor(private navigateService: NavigateService, private readonly translocoService: TranslocoService) {
    this.translated = {
      editSlide: this.translocoService.translate('buttons.editSlide'),
      createSlide: this.translocoService.translate('buttons.createSlide'),
    };
  }

  ngOnInit(): void {}

  ngOnChanges({ imageUrl }: SimpleChanges): void {
    if (imageUrl && imageUrl.currentValue) {
      this.imageUrlWithRefresh = Utils.addRefreshParamToImage(imageUrl.currentValue);
    }
  }

  get backgroundImageUrl() {
    return this.imageUrl ? `url(${this.imageUrlWithRefresh})` : null;
  }

  get buttonTooltip(): string {
    return this.id!! ? `${this.translated.editSlide} ${this.id}` : `${this.translated.createSlide}`;
  }

  addSlide() {
    this.navigateService.navigate(URL_ROUTER.slideAdd(), {
      queryParams: { page: this.page, isPageHeader: this.isHomePage() },
    });
  }

  editSlide() {
    if (this.isHome) {
      this.navigateService.navigate(URL_ROUTER.settingsHomeSlider(), {
        queryParams: { page: this.page, isPageHeader: false },
      });
    } else {
      this.navigateService.navigate(URL_ROUTER.slideEdit(this.id), {
        queryParams: { page: this.page, isPageHeader: true },
      });
    }
  }

  private isHomePage(): boolean {
    return this.page !== Pages.HOME;
  }
}
